import React from 'react';
import { ErrorMessage, Field } from 'formik';

export const StepThree = () => {
  return (
    <div className=" w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step3">
      {/* <h6 className="text-lg font-bold mb-6">Financial Information</h6> */}

      <div className="mb-6 form-radio2-main">
        <label className="block text-gray-700 font-medium mb-2">
          Annual income <span>*</span>
        </label>
        <div className="space-y-2">
          <div className="flex items-center form-radio2">
            <Field
              type="radio"
              id="annualIncome0-30000"
              name="salary"
              value="£0 - £30,000"
              className="mr-2"
            />
            <label htmlFor="annualIncome0-30000">£0 - £30,000</label>
          </div>
          <div className="flex items-center form-radio2">
            <Field
              type="radio"
              id="annualIncome30000-50000"
              name="salary"
              value="£30,000 - £50,000"
              className="mr-2"
            />
            <label htmlFor="annualIncome30000-50000">£30,000 - £50,000</label>
          </div>
          <div className="flex items-center form-radio2">
            <Field
              type="radio"
              id="annualIncome50000-100000"
              name="salary"
              value="£50,000 - £100,000"
              className="mr-2"
            />
            <label htmlFor="annualIncome50000-100000">£50,000 - £100,000</label>
          </div>
          <div className="flex items-center form-radio2">
            <Field
              type="radio"
              id="annualIncome100000+"
              name="salary"
              value="£100,000 +"
              className="mr-2"
            />
            <label htmlFor="annualIncome100000+">£100,000 +</label>
          </div>
          <ErrorMessage name="salary" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
